<template>
  <div>
    <div v-show="value">
      <div class="noticeWarning dark:bg-purple-600 border-2 dark:text-white">
        <button
          v-on:click="closeCautionNotice"
          id="button-close"
          class="block float-right relative"
          aria-label="Close"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#F2F2F2"></circle>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3969 12.2496C11.5347 12.1117 11.7582 12.1117 11.8961 12.2496L23.7513 24.1048C23.8891 24.2426 23.8891 24.4661 23.7513 24.604C23.6134 24.7418 23.3899 24.7418 23.2521 24.604L11.3969 12.7488C11.259 12.6109 11.259 12.3874 11.3969 12.2496Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.2496 24.6041C11.1117 24.4662 11.1117 24.2427 11.2496 24.1049L23.1048 12.2497C23.2426 12.1119 23.4661 12.1119 23.604 12.2497C23.7418 12.3876 23.7418 12.6111 23.604 12.7489L11.7488 24.6041C11.6109 24.7419 11.3874 24.7419 11.2496 24.6041Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
          </svg>
        </button>
        <!-- TODO add the crisis boolean 
        <h2 class="questionTitle inline dark:text-white">Are you in crisis?</h2>
        -->
        <h2 class="questionTitle dark:text-white">Are you in crisis?</h2>

        <div data-aos="fade-left" class="radio-toolbar">
          <span>
            <input
              type="radio"
              id="option1"
              v-on:click="closeCautionNotice"
              name="crisis"
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              No</label
            >
          </span>
          <span>
            <input
              type="radio"
              id="option2"
              v-on:click="setCrisisTrue"
              name="crisis"
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple">
              Yes</label
            >
          </span>
        </div>
        <div role="dialog">
          <p class="font-normal text-sm mb-6 dark:text-white">
            Please note that the Wellness Services Navigator tool is not
            designed for urgent or crisis support. If you are worried about harm
            to yourself or others in any way, we urge you to
            <a
              class="text-link-blue dark:text-link-light-blue font-bold pb-1"
              target="_blank"
              href="https://wellness.carleton.ca/get-help-now/"
              >reach out for assistance.
            </a>
          </p>
        </div>
      </div>
      <div
        v-on:click="closeCautionNotice"
        id="background-opacity"
        class="fixed w-full h-full bg-black top-0 bottom-0 opacity-20 z-30"
      ></div>
    </div>
  </div>
</template>

<script>
import store from "../store";
export default {
  name: "Notice",
  props: ["caution"],
  data() {
    return {
      cautionNotice: true,
      showCrisisLink: false,
      forcePageOpen: false,
      value: {
        type: Boolean,
        required: true,
      },
    };
  },
  methods: {
    closeCautionNotice() {
      //if (!this.forcePageOpen) {
      this.$emit("input", !this.value);
      store.state.views.questionOne.nextButtonActive = true;
      //store.commit("closeWarningDialog");
      // }
    },

    setCrisisFalse() {
      this.showCrisisLink = false;
    },

    setCrisisTrue() {
      //this.showCrisisLink = true;
      location.reload();
      //this will only append to the url once
      if (window.location.href.indexOf("?crisis=true") == -1) {
        window.location.href += "?crisis=true";
      }
    },
  },
};
</script>

<style lang="css" scoped>
.continuumButtonLarge {
  display: block;
}

.continuumButtonSmall {
  display: none;
}
.noticeWarning {
  @apply fixed p-8 bg-white shadow-lg z-50;
  margin-left: 1rem;
  margin-right: 1rem;
  text-align: left;
  top: 50%;
  left: 0;
  right: 0;
  margin: auto;
  transform: translateY(-50%);
  width: 50%;
  border-radius: 20px;
}

@media only screen and (max-width: 920px) {
  .noticeWarning {
    width: 75%;
  }
}

@media only screen and (max-width: 640px) {
  .noticeWarning {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    position: fixed;
    @apply p-8;
  }

  .continuumButtonLarge {
    display: none;
  }

  .continuumButtonSmall {
    display: block;
  }
}

.switch {
  position: relative;
  display: inline-block;
  width: 70px;
  height: 26px;
  top: -2px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider_checkbox {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d34848;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider_checkbox:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider_checkbox::after {
  position: absolute;
  content: "Crisis";

  height: 18px;
  width: 18px;
  left: 25px;
  bottom: 4px;
  top: 0px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider_checkbox {
  background-color: #18c23e;
}

input:focus + .slider_checkbox {
  box-shadow: 0 0 1px #18c23e;
}

input:checked + .slider_checkbox:before {
  -webkit-transform: translateX(43px);
  -ms-transform: translateX(43px);
  transform: translateX(43px);
}

input:checked + .slider_checkbox::after {
  -webkit-transform: translateX(-19px);
  -ms-transform: translateX(-19px);
  transform: translateX(-19px);
}

/* Rounded sliders */
.slider_checkbox.round {
  border-radius: 34px;
}

.slider_checkbox.round:before {
  border-radius: 50%;
}
</style>
